"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLastNetworkErrorMessage = exports.updateRequestStatus = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    requests: {},
    lastNetworkErrorMessage: '',
};
var networkStatusSlice = toolkit_1.createSlice({
    name: 'networkStatus',
    initialState: initialState,
    reducers: {
        updateRequestStatus: function (state, action) {
            var _a = action.payload, id = _a.id, status = _a.status;
            state.requests[id] = status;
        },
        updateLastNetworkErrorMessage: function (state, action) {
            state.lastNetworkErrorMessage = action.payload;
        },
    },
});
exports.updateRequestStatus = (_a = networkStatusSlice.actions, _a.updateRequestStatus), exports.updateLastNetworkErrorMessage = _a.updateLastNetworkErrorMessage;
exports.default = networkStatusSlice.reducer;
//# sourceMappingURL=networkStatusSlice.js.map